import {pluralize} from "@pg-mono/string-utils";

export const packagesPluralize = pluralize(["pakiet wykończeniowy", "pakiety wykończeniowe", "pakietów wykończeniowych"]);
export const yearsPluralize = pluralize(["rok", "lata", "lat"]);
import {pluralize} from "@pg-mono/string-utils";

export const packagesPluralize = pluralize(["pakiet wykończeniowy", "pakiety wykończeniowe", "pakietów wykończeniowych"]);
export const yearsPluralize = pluralize(["rok", "lata", "lat"]);
